export default __webpack_public_path__ + "5532bea71801cafa01ac4e1068f62b9c.mp3";